import { FileMedia, IFileMedia } from "./file-media.model";
import { IService, Service } from "./service.model";
// import { HouseFlat, IHouseFlat } from "./house-flat.model";
import { IVisitType, VisitType } from "./visit-type.model";

export interface IVisit {
  // visitId: string;
  shortCode: string;
  // visitTypeId: string;
  // superVisitId?: string;
  // neighborhoodId: string;
  // streetBuildingId?: string;
  // houseFlatId?: string;
  // contactId?: string;
  names: string;
  paternalLastName: string;
  maternalLastName?: string;
  plates: string;
  brand: string;
  model: string;
  color: string;
  description: string;
  isMotorcycle: boolean;
  status: boolean;
  approved?: boolean;
  passengersNumber: number;
  dueDate?: string
  manuallyClosed: boolean;
  token: string;
  arrivedAt?: string;
  departedAt?: string;
  visitType?: IVisitType;
  // houseFlat?: IHouseFlat;
  service?: IService;
}

export class Visit {
  // visitId: string;
  shortCode: string;
  // visitTypeId: string;
  // superVisitId?: string;
  // neighborhoodId: string;
  // streetBuildingId?: string;
  // houseFlatId?: string;
  // contactId?: string;
  names: string;
  paternalLastName: string;
  maternalLastName?: string;
  plates: string;
  brand: string;
  model: string;
  color: string;
  description: string;
  isMotorcycle: boolean;
  status: boolean;
  approved?: boolean;
  passengersNumber: number;
  dueDate?: string
  manuallyClosed: boolean;
  token: string;
  arrivedAt?: Date;
  departedAt?: Date;
  // uidCreatedBy?: string;
  // uidUpdatedBy?: string;
  // createdAt: Date;
  // updatedAt: Date;
  visitType?: VisitType;
  // houseFlat?: HouseFlat;
  service?: Service;

  constructor(data: IVisit) {
    // this.visitId = data.visitId;
    this.shortCode = data.shortCode;
    // this.visitTypeId = data.visitTypeId;
    // this.superVisitId = data.superVisitId;
    // this.neighborhoodId = data.neighborhoodId;
    // this.streetBuildingId = data.streetBuildingId;
    // this.houseFlatId = data.houseFlatId;
    // this.contactId = data.contactId;
    this.names = data.names;
    this.paternalLastName = data.paternalLastName;
    this.maternalLastName = data.maternalLastName;
    this.plates = data.plates;
    this.brand = data.brand;
    this.model = data.model;
    this.color = data.color;
    this.description = data.description;
    this.isMotorcycle = data.isMotorcycle;
    this.status = data.status;
    this.approved = data.approved;
    this.passengersNumber = data.passengersNumber;
    this.dueDate = data.dueDate;
    this.manuallyClosed = data.manuallyClosed;
    this.token = data.token;
    this.arrivedAt = data.arrivedAt ? new Date(data.arrivedAt) : undefined;
    this.departedAt = data.departedAt ? new Date(data.departedAt) : undefined;
    // this.uidCreatedBy = data.uidCreatedBy;
    // this.uidUpdatedBy = data.uidUpdatedBy;
    // this.createdAt = new Date(data.createdAt);
    // this.updatedAt = new Date(data.updatedAt);
    this.visitType = data.visitType 
      ? new VisitType(data.visitType) 
      : undefined
    // this.houseFlat = data.houseFlat
    //   ? new HouseFlat(data.houseFlat)
    //   : undefined;
    this.service = data.service
      ? new Service(data.service)
      : undefined;
  }

  get fullName(): string {

    return `${this.names} ${this.paternalLastName} ${this.maternalLastName}`;
  }

  get isVehicle(): boolean {
    return this.visitType?.description === 'En vehículo' || this.visitType?.description === 'Servicio' || this.visitType?.description === 'Proveedor';
  }
}
